import { render, staticRenderFns } from "./MapComponent.vue?vue&type=template&id=2b4b99b2&scoped=true&"
import script from "./MapComponent.vue?vue&type=script&lang=ts&"
export * from "./MapComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MapComponent.vue?vue&type=style&index=0&id=2b4b99b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b99b2",
  null
  
)

export default component.exports